/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bar:hover{fill:#6ab7ff}.title{font-weight:400;font-size:12px;text-transform:uppercase}#diff-exp-btn{margin-bottom:10px}"];
export { styles as styles };
